import React from "react";

import "./Home.css";
import losdesafios_logo from "images/custom/home/home_graphic.png";
import { FEATURED_PROJECTS, MY_PROJECTS } from "App/Routes";
import Link from "components/shared/Link/Link";
import HomePage from "components/Home/HomePage";

import { ENABLE_FEATURED_GAMES, ENABLE_MY_GAMES } from "config";
import localize from "lang/localize";

class LosDesafiosHomePage extends HomePage {
  renderHomeButtons() {
    return (
      <div className="home-buttons">
        {/* Custom: Custom renderFeaturedGamesButton function */}
        {this.renderFeaturedGamesButton()}
        {/* Custom: Custom renderMyGamesButton function */}
        {this.renderMyGamesButton()}
        {/* Custom: Custom renderBottomButtons function */}
        {this.renderBottomButtons()}
        {/* Custom: render 'Powered by Gametize' */}
        {this.renderPoweredByContainer()}
      </div>
    );
  }

  renderFeaturedGamesButton() {
    if (ENABLE_FEATURED_GAMES) {
      return (
        <div className="pure-u-g">
          <div className="pure-u-1-8 pure-u-md-1-6 pure-u-lg-5-24 pure-u-xl-7-24" />
          <div className="pure-u-3-4 pure-u-md-2-3 pure-u-lg-7-12 pure-u-xl-5-12">
            {/* Custom: Capitalized button */}
            <Link to={FEATURED_PROJECTS} className="button cta capitalize">
              {localize("button_mygames_gametize", this.props.language)}
            </Link>
          </div>
          <div className="pure-u-1-8 pure-u-md-1-6 pure-u-lg-5-24 pure-u-xl-7-24" />
        </div>
      );
    } else {
      return null;
    }
  }

  renderMyGamesButton() {
    if (ENABLE_MY_GAMES) {
      return (
        <div className="pure-u-g">
          <div className="pure-u-1-8 pure-u-md-1-6 pure-u-lg-5-24 pure-u-xl-7-24" />
          <div className="pure-u-3-4 pure-u-md-2-3 pure-u-lg-7-12 pure-u-xl-5-12">
            {/* Custom: Capitalized button */}
            <Link to={MY_PROJECTS} className="button cta capitalize">
              {localize("button_mygames_gametize", this.props.language)}
            </Link>
          </div>
          <div className="pure-u-1-8 pure-u-md-1-6 pure-u-lg-5-24 pure-u-xl-7-24" />
        </div>
      );
    } else {
      return null;
    }
  }

  renderBottomButtons() {
    return (
      <div className="pure-u-g">
        <div className="pure-u-1-24 pure-u-md-1-12 pure-u-lg-1-6 pure-u-xl-1-4" />
        <div className="pure-u-11-12 pure-u-md-5-6 pure-u-lg-2-3 pure-u-xl-1-2 bottom-links">
          <div className="pure-u-1-2 horizontalpadding-5">
            <a
              className="button fullwidth align-items-center justify-content-center small"
              href="https://www.doit.com.mx/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {localize("button_home_doit", this.props.language)}
            </a>
          </div>
          <div className="pure-u-1-2 horizontalpadding-5">
            <a
              href="https://www.starservice.com.mx/"
              target="_blank"
              rel="noopener noreferrer"
              className="button fullwidth align-items-center justify-content-center small"
            >
              {localize("button_home_starservice", this.props.language)}
            </a>
          </div>
        </div>
        <div className="pure-u-1-24 pure-u-md-1-12 pure-u-lg-1-6 pure-u-xl-1-4" />
      </div>
    );
  }

  /* Custom: Changed logo */
  renderHomeLogo() {
    return (
      <div className="home-logo-container">
        <img className="imgresponsive" src={losdesafios_logo} alt="" />
      </div>
    );
  }
}

export default LosDesafiosHomePage;
